export var PaymentTarget;
(function (PaymentTarget) {
    PaymentTarget["PREVENTION_COURSE"] = "PREVENTION_COURSE";
    PaymentTarget["OFFICE_LOCATION"] = "OFFICE_LOCATION";
    PaymentTarget["CONNECT_OFFICE_PRODUCT"] = "CONNECT_OFFICE_PRODUCT";
    PaymentTarget["APPLICATION_FEE"] = "APPLICATION_FEE";
})(PaymentTarget || (PaymentTarget = {}));
//# sourceMappingURL=payment-target.enum.js.map